import PasskeyOptinModal from 'components/GlobalModals/PasskeyOptinModal/PasskeyOptinModal';
import { withPasskeyOptinModalProps } from 'viewModel/globalModals/passkeyOptinModal/withPasskeyOptinModalProps';

export default withPasskeyOptinModalProps(PasskeyOptinModal);
